module.exports = __webpack_public_path__ + "img/图层 13.192ccab1.png";